import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadTemplateAttributesFailed, loadTemplateAttributesSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, DEFAULT_ITEMS_OF_PAGE } from '../../../configs';

export default function* loadTemplateAttributes(action) {
  try {
    const url = `${BACKEND_URL}/resources/load-template-attributes`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadTemplateAttributesSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadTemplateAttributesFailed());
      yield call(rejectActionPromise(action, data.data));
    }
    // /* ["carriers_and_vehicles", "order_services", "total", "average"] */
    // yield put(loadTemplateAttributesSuccessful([
    //   {
    //     id: 'total',
    //     name: 'Общее значение',
    //   },
    //   {
    //     id: 'average',
    //     name: 'Среднее значение',
    //   },
    //   {
    //     id: 'order_services',
    //     name: 'Услуги по СЗЛТ',
    //   },
    //   {
    //     id: 'carriers_and_vehicles',
    //     name: 'Услуги по РП и ЛТ',
    //   },
    // ]));
  } catch (e) {
    yield put(loadTemplateAttributesFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
